import { useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";

const PermanentDeleteAccount = ({ auth, Show, Hide, Title, isDark, getAccountList, setUpdator }) => {
  const [password, setPassword] = useState("");
  const deletePermanentAccount = () => {

  }
  return (
    <Modal show={Show} onHide={Hide} size="md">
      <Modal.Header
        closeButton
        className={`${isDark ? "bg-dark text-light" : "bg-light"} p-3 border-bottom`}
      >
        <Modal.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`rounded-bottom ${isDark ? "bg-dark" : "bg-white"}`}>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Password
          </Form.Label>
          <Form.Control
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Password"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <div className="hstack justify-content-end">
          <Button
            disabled={!password}
            variant="outline-danger"
            style={{ fontSize: 13 }}
            onClick={() => { Hide(); deletePermanentAccount() }}
            title="Permanently Delete Account"
            className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
          >
            <FaTrashAlt /> Permanently Delete Account
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PermanentDeleteAccount;
